"use client";

import React from "react";
import overviewIcon from "../assets/images/trading/overview.svg";
import marketIcon from "../assets/images/trading/market.svg";
import buySellIcon from "../assets/images/trading/buySell.svg";
import sendIcon from "../assets/images/trading/sendReceive.svg";
import withdrawDepositIcon from "../assets/images/trading/widtdrawDeposit.svg";
import eightyEightPayIcon from "../assets/images/trading/88Pay.svg";
import accountIcon from "../assets/images/trading/account.svg";
import businessAccountIcon from "../assets/images/trading/businessAccount.svg";
import { useFeatureFlagsByCategory } from "../hooks/query/queries";
import { useKybStatus } from "../hooks/useKybStatus";
import KybStatusBadge from "./ui/kyb-status-badge";

const useCombinedFeatureFlags = () => {
  const { data: mainFeatures } = useFeatureFlagsByCategory("mainFeatures");
  const { data: settingsPage } = useFeatureFlagsByCategory("settingsPage");
  return { mainFeatures, settingsPage };
};

const SvgIcon = ({ src, isActive }) => {
  const color = isActive ? "#33125F" : "#6D6584";

  const getFilter = (hexColor) => {
    if (hexColor === "#33125F") {
      return "brightness(0) saturate(100%) invert(20%) sepia(50%) saturate(2000%) hue-rotate(250deg) brightness(0.8) contrast(1.2)";
    }
    return "brightness(0) saturate(100%) invert(42%) sepia(8%) saturate(1234%) hue-rotate(218deg) brightness(95%) contrast(87%)";
  };

  return (
    <img
      src={src}
      alt=""
      className="w-[24px] h-[24px] flex items-center justify-center"
      style={{
        filter: getFilter(color),
        display: "block",
      }}
    />
  );
};

export default function SideNav({ activeTab, onTabChange, mainAccount }) {
  const { mainFeatures: featureFlags, settingsPage } =
    useCombinedFeatureFlags();
  const { status: kybStatus } = useKybStatus();

  const navItems = [
    {
      id: "overview",
      label: "Overview",
      icon: overviewIcon,
      svg: true,
    },
    mainAccount && {
      id: "market",
      label: "Market",
      icon: marketIcon,
      svg: true,
    },
    (featureFlags?.buyCrypto || featureFlags?.sellCrypto) && {
      id: "buy-sell",
      label: "Buy / Sell",
      icon: buySellIcon,
      svg: true,
    },
    mainAccount &&
      (featureFlags?.sendCrypto || featureFlags?.receiveCrypto) && {
        id: "send-receive",
        label: "Send / Receive",
        icon: sendIcon,
        svg: true,
      },
    mainAccount &&
      (featureFlags?.deposit || featureFlags?.withdraw) && {
        id: "withdraw-deposit",
        label: "Withdraw / Deposit",
        icon: withdrawDepositIcon,
        svg: true,
      },
    mainAccount &&
      featureFlags?.eightPay && {
        id: "80eightpay",
        label: "80eight Pay",
        icon: eightyEightPayIcon,
        svg: true,
      },
    mainAccount &&
      settingsPage?.addressBook && {
        id: "address-book",
        label: "Address book",
        icon: accountIcon,
        svg: true,
      },
    settingsPage?.corporateAccount && {
      id: "business-account",
      label: "Business Account",
      icon: businessAccountIcon,
      svg: true,
      badge: kybStatus,
    },
  ].filter(Boolean);

  return (
    <nav className="flex lg:flex-col flex-wrap pb-3 lg:space-y-3 lg:justify-start justify-center lg:items-start items-center">
      {navItems.map(({ id, label, icon: Icon, svg, badge }) => {
        const isActive = activeTab === id;
        return (
          <button
            key={id}
            onClick={() => onTabChange(id)}
            className={`relative flex items-center gap-[12px] w-full rounded-full py-[16px] px-[24px] border border-[1px]  ${
              isActive
                ? " border-[#6D6584] text-[#33125F] font-semibold"
                : " border-transparent text-[#6D6584] font-normal"
            }`}
          >
            {svg ? (
              <SvgIcon src={Icon} alt={label} isActive={isActive} />
            ) : (
              <Icon size={24} />
            )}
            <span className="text-[14px] ">{label}</span>
            {badge && <KybStatusBadge status={badge} className="ml-auto" />}
          </button>
        );
      })}
    </nav>
  );
}
